import clsx from 'clsx';

/** An adapter's inline SVG as an image: `<img>` can't run a script an adapter's markup might carry, which inlining it would. */
export function AdapterLogo({ logoSvg, name, className }: { logoSvg: string; name: string; className?: string }) {
  return (
    <img src={`data:image/svg+xml,${encodeURIComponent(logoSvg)}`} alt={`${name} logo`} className={clsx('size-10 rounded-md object-contain', className)} />
  );
}
